import { Button, message } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import SignaturePad from 'react-signature-pad-wrapper';
import LilyButton from '../../components/button/lily-button';
import portalAPI from '../../api/api';
import { UPLOAD_IMAGE_URL } from '../../api/URLs';

const SignatureComponenet = (props) => {
    const { singedLink, handleSignature, submitting, setSigning } = props;
    const [signLoading, setSignLoading] = useState(false);
    const [signaturePadRef, setSignaturePadRef] = useState();
    const [signatureBase64, setSignatureBase64] = useState('');
    const [signatureLink, setSignatureLink] = useState('');
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        if (signaturePadRef) {
            signaturePadRef.instance.addEventListener('endStroke', onStrokeEnd);
            if (activeTab === 0 && signatureBase64) {
                signaturePadRef.fromDataURL(signatureBase64);
            }
        }
    }, [signaturePadRef]);

    const onStrokeEnd = () => {
        setSignatureBase64(signaturePadRef.toDataURL());
    };

    const submitSignature = async () => {
        setSignLoading(true);
        setSigning(true);
        try {
            const response = await portalAPI.post(UPLOAD_IMAGE_URL, {
                folderType: 'patient-signature',
                image: signatureBase64.split(',')[1],
            });
            if (response.data.result) {
                let rsp = response?.data?.data;
                setSignatureBase64(signaturePadRef.toDataURL());
                setSignatureLink(rsp.presignedUrl);
                handleSignature(rsp.presignedUrl, rsp.url, rsp.s3key);
                signaturePadRef?.off();
            }
        } catch (err) {
            message.error(err.message);
        } finally {
            setSignLoading(false);
            setSigning(false);
        }
    };

    const handleClearSignature = () => {
        signaturePadRef.clear();
        signaturePadRef?.on();
        setSignatureBase64('');
        setSignatureLink('');
        handleSignature('', '', '');
    }

    useEffect(() => {
        if (signaturePadRef && singedLink) {
            signaturePadRef.fromDataURL(singedLink);
            signaturePadRef?.off(); // Optional: prevent further drawing
        }
    }, [signaturePadRef, singedLink]);

    return (
        <div className='d-flex flex-column gap-3' style={{ maxWidth: '500px' }}>
            <div style={{ border: '1px solid #d9d9d9', borderRadius: '8px', overflow: 'hidden', height: '248px' }}>
                <SignaturePad
                    ref={(node) => {
                        if (node) {
                            setSignaturePadRef(node);
                        }
                    }}
                    options={{ backgroundColor: '#ffffff' }}
                />
            </div>
            <div className="d-flex justify-content-end">
                <div className='d-flex flex-row align-items-center gap-3'>
                    <Button
                        disabled={signLoading || submitting}
                        onClick={handleClearSignature}
                    >
                        Clear
                    </Button>
                    <LilyButton disabled={signatureLink !== '' || !signatureBase64} text="Use This Signature" style={{ borderRadius: '5px' }} loading={signLoading} onClick={submitSignature} />
                </div>
            </div>
        </div>
    )
}

export default SignatureComponenet